import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PackagesTable from './packagesTable';
import Button from 'components/button';
import PackageForm from './packageForm';

const Packages = () => {
  const [showCreatePackage, setShowCreatePackage] = useState(false);
  const [duplicateData, setDuplicateData] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.isDuplicate && location.state?.packageData) {
      const packageData = location.state.packageData;
      
      const duplicatedPackage = {
        ...packageData,
        packageName: `${packageData.packageName} (Copy)`,
        startDate: '',
        endDate: '',
        availableSeats: packageData.totalSeats,
      };
      
      delete duplicatedPackage._id;
      delete duplicatedPackage.metadata;
      delete duplicatedPackage.__v;
      delete duplicatedPackage.createdAt;
      delete duplicatedPackage.updatedAt;
      
      setDuplicateData(duplicatedPackage);
      setShowCreatePackage(true);
      
      
      navigate('/admin/package', { replace: true });
    }
  }, [location, navigate]);

  const handleToggleCreatePackage = () => {
    setShowCreatePackage((prevState) => !prevState);
    if (!showCreatePackage === false) {
      setDuplicateData(null);
    }
  };

  return (
    <div>
      <Button
        onClick={handleToggleCreatePackage}
        extraClasses="ml-auto mr-4 mb-4"
      >
        {showCreatePackage ? 'Back' : 'Add New Package'}
      </Button>
      {showCreatePackage ? (
        <PackageForm 
          type="Create" 
          formValues={duplicateData}
          handleToggleCreatePackage={handleToggleCreatePackage} 
        />
      ) : (
        <PackagesTable />
      )}
    </div>
  );
};

export default Packages;
